import React, { useState, forwardRef } from 'react';
import { toast } from 'react-toastify';
import Box from '@mui/material/Box';
import IconToast from '../NewToast';
import { handleError } from '../../utils/openai';
import { openaiGenerateWithTextStreaming } from '../../store/openai/api';
import RecordDialog from '../RecordDialog/RecordDialog';
import LoadingBackdrop from '../LoadingBackdrop/LoadingBackdrop';
import { speechToText } from '../../store/speech/api';
import { injectIntl } from 'react-intl';
import NativeOrWeb from '../../utils/native';
import { tracking } from '../../utils/tracking';
import { trackDirect } from '../../store/analytics/api';

// v9: forwardRef render must accept (props, ref). The ref is unused here but
// must be present to silence the React warning.
// eslint-disable-next-line no-unused-vars
const GeneralVoiceWithAiButton = forwardRef((props, ref) => {
  const { intl, title, content, completeAction, specialPrompt, trackDirectName, trackName, customButton } = props;

  const [initializing, setInitializing] = useState(false);
  const [recordingDialogOpen, setRecordingDialogOpen] = useState(false);
  const [recording, setRecording] = useState(false);
  const [loading, setLoading] = useState(false);

  const openDialog = () => {
    setRecordingDialogOpen(true);
  };

  const startRecording = async () => {
    try {
      setRecording(true);
      setInitializing(true);
      trackDirect(trackDirectName);
      tracking(trackName);

      await NativeOrWeb.startRecordingVoice();
    } catch (error) {
      console.log(error);
      toast.info(IconToast('error', intl.formatMessage({ id: 'error-msg' })), { className: 'new-toast' });
      setRecordingDialogOpen(false);
    } finally {
      setInitializing(false);
    }
  };

  const cancelRecording = () => {
    setRecordingDialogOpen(false);
    setRecording(false);
    if (recording) {
      NativeOrWeb.stopRecordingVoice()
        .then()
        .catch(console.log);
    }
  };

  const stopRecording = async () => {
    try {
      setRecordingDialogOpen(false);
      setRecording(false);
      setLoading(true);

      const recordingData = await NativeOrWeb.stopRecordingVoice();
      const { mimeType, msDuration, recordDataBase64 } = recordingData?.value || {};
      const speechToTextResult = await speechToText({ mimeType, msDuration, recordDataBase64 });

      const { text: speechText } = speechToTextResult?.result || {};
      console.log(speechText);

      await openaiGenerateWithTextStreaming(
        specialPrompt,
        { speechText },
        [],
        null,
        completeAction,
        setLoading
      );
    } catch (error) {
      handleError(error);
      setLoading(false);
    }
  };

  return (
    <>
      <RecordDialog
        title={intl.formatMessage({ id: title })}
        content={intl.formatMessage({ id: content })}
        timeLimit={120}
        open={recordingDialogOpen}
        initializing={initializing}
        recording={recording}
        onClose={cancelRecording}
        onStartRecording={startRecording}
        onDoneRecording={stopRecording}
      />
      <LoadingBackdrop open={loading} />
      <Box onClick={openDialog}>{customButton}</Box>
    </>
  );
});

export default injectIntl(GeneralVoiceWithAiButton);
